import { enableMapSet } from 'immer';
import { enableTransmute } from 'immutable-less'; // @ts-expect-error remove once upstream deps are typed

import App from './App';
enableMapSet();
enableTransmute();
new App().start();